import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSignUp } from "@clerk/clerk-react";
import OtpVerification, {
  INVALID_CODE_MESSAGE,
} from "../../components/otpVerification";
import { routeEndpoints } from "../../routes/routeEndpoints";

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const { isLoaded, signUp, setActive } = useSignUp();
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (!isLoaded || hasCompletedRef.current || signUp.status !== null) return;

    navigate(routeEndpoints.signup, { replace: true });
  }, [isLoaded, signUp, navigate]);

  const handleVerify = async (code: string) => {
    if (!isLoaded) return INVALID_CODE_MESSAGE;

    const attempt = await signUp.attemptEmailAddressVerification({ code });

    if (attempt.status !== "complete") return INVALID_CODE_MESSAGE;

    hasCompletedRef.current = true;
    await setActive({ session: attempt.createdSessionId });
    navigate(routeEndpoints.orders, { replace: true });
  };

  const handleResend = async () => {
    if (!isLoaded) return;

    await signUp.prepareEmailAddressVerification({ strategy: "email_code" });
  };

  return (
    <OtpVerification
      backLabel="Back to Sign up"
      backTo={routeEndpoints.signup}
      isLoaded={isLoaded}
      onVerify={handleVerify}
      onResend={handleResend}
    />
  );
}
